fragment EntitySummaryFragment on EntitySummary {
    id
    status
    summary
    userRating
    createdTime
    userRating
}
